<template>
    <div class="ChildList" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf" id="divTopToHalf">
            <h2>
                Foster Children Enrollments
                <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" />
                <span v-b-tooltip.hover title="Hide/Show Filters" style="margin-left:6px;margin-right:6px;">
                    <font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" />
                </span>
                <EmployeeColumnCustomizationEditor update-event-message="update-table-columns" :table-fields="VisibleFields" table-label="Child List" columns-defaults-endpoint="Foster/FosterClients/GetTableColumns" table-settings-name="Foster Client Table">
                </EmployeeColumnCustomizationEditor>
            </h2>            
            <div class="table-filters" v-show="ShowFilters">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Child Status:</label>
                            <select class="form-control" v-model="Filters.ChildStatus" @change="RefreshDataTable()">
                                <option value="All">All</option>
                                <option value="Active">Active</option>
                                <option value="Terminated">Terminated</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Program:</label>
                            <select class="form-control" v-model="Filters.SubProgramID" @change="RefreshDataTable()">
                                <option v-if="CheckPermission('CanAccessAllOptionInSubPrograms')" value="">All</option>
                                <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        Displaying {{NumberOfClients}} Records
                    </div>
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Search Clients:</label>
                            <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="overflow:auto;">
            <vuetable :fields="VisibleFields"
                        pagination-path=""
                        :api-mode="false"
                        class="vue-datatable"
                        :data-manager="DataManager"
                        ref="datatable"
                        id="childrendatatableid">

                <template slot="ChildRecordLinkFirst" scope="props">
                    <div class="ChildRecordLinkFirst">
                        <span class="underline pointer" @click="OpenChildRecord(props.rowData.ClientProgramMembership.Id, props.rowData)" v-html="props.rowData.Client.Person.AKA ? props.rowData.Client.Person.FirstName + ' &quot;' + props.rowData.Client.Person.AKA + '&quot;' : props.rowData.Client.Person.FirstName"></span>
                    </div>
                </template>
                <template slot="ChildRecordLinkLast" scope="props">
                    <div class="ChildRecordLinkLast">
                        <span class="underline pointer bold" @click="OpenChildRecord(props.rowData.ClientProgramMembership.Id, props.rowData)" v-html="props.rowData.Client.Person.LastName"></span>
                    </div>
                </template>
                <template slot="LastNameFirstInitial" scope="props">
                    <div class="LastNameFirstInitial">
                        <span class="underline pointer" @click="OpenChildRecord(props.rowData.ClientProgramMembership.Id, props.rowData)" v-html="props.rowData.Client.Person.LastNameFirstInitial"></span>
                    </div>
                </template>
            </vuetable>
        </div>
    </div>
</template>

<script>
    //import services
    import { ClientsAPI } from '../../../services/api/Foster/ClientsAPI.js';
    
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import { EventBus } from '../../../services/event-bus.js';
    import EmployeeColumnCustomizationEditor from "../../Core/ItemEditors/EmployeeColumnCustomizationEditor.vue";
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
    library.add(faCaretDown);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);

    //MIXINS
    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";

    export default {
        mixins: [
            TableScrollerSupport
        ],
        created() {
            this.$store.commit("Clients.ClientProfiles.Clear");
            this.$store.commit("Clients.ClientEnrollmentsList.Clear");
            const clientsAPI = new ClientsAPI(this.$baseURL);
            this.clientsAPI = clientsAPI;
            EventBus.$on('global-update-initiated', this.GetChildren);
            EventBus.$on('update-table-columns', this.RefreshDataTable);
        },
        beforeDestroy() {
            EventBus.$off('global-update-initiated');
            EventBus.$off('update-table-columns');
        },
        props: [],
        data: function () {
            return {
                CaseManagers: '',
                NumberOfClients: '',
                search: "",
                VisibleFields: [],
                Filters: {
                    ChildStatus: "Active",
                    SubProgramID: "",
                    CaseManagerID: ""
                },
                ChildrenTableOptions: {
                    Fields: [
                        {
                            name: '__slot:LastNameFirstInitial',
                            title: 'Name',
                            sortField: 'Client.Person.LastNameFirstInitial',
                        },
                        {
                            name: '__slot:ChildRecordLinkLast',
                            title: 'Last',
                            sortField: 'Client.Person.LastName',
                        },
                        {
                            name: 'Client.Person.LastName',
                            title: 'Last',
                            visible: false,
                            Save: true,
                        },
                        {
                            name: '__slot:ChildRecordLinkFirst',
                            title: 'First',
                            sortField: 'Client.Person.FirstName',
                        },
                        {
                            name: 'Client.Person.FirstName',
                            title: 'First',
                            visible: false,
                            Save: true,
                        },
                        {
                            name: 'Client.Person.DOB',
                            title: "DOB",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'Client.Person.DOB',
                        },
                        {
                            name: 'Client.Person.AgeString',
                            title: "Age",
                            dataClass: 'td-nowrap',
                            sortField: 'Client.Person.DOB',
                        },
                        {
                            name: 'ClientProgramMembership.SubProgramName',
                            title: "Program",
                            sortField: 'ClientProgramMembership.SubProgramName',
                        },
                        {
                            name: 'ClientProgramMembership.StartDate',
                            title: "Start Date",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'ClientProgramMembership.StartDate',
                        },
                        {
                            name: 'ClientProgramMembership.EndDate',
                            title: "Term Date",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'ClientProgramMembership.EndDate',
                        },
                        {
                            name: 'ClientProgramMembership.CurrentCensusProgramService',
                            title: "Enrollment",
                            sortField: 'ClientProgramMembership.CurrentCensusProgramService',
                        },
                        {
                            name: 'CurrentResourceFamily',
                            title: "Family",
                            sortField: 'CurrentResourceFamily',
                        },
                        {
                            name: 'CurrentCaseManager',
                            title: "Case Manager",
                            sortField: 'CurrentCaseManager',
                        },
                        {
                            name: 'SocialWorker',
                            title: "Social Worker",
                            sortField: 'SocialWorker',
                        },
                        {
                            name: 'Location',
                            title: "Location",
                            sortField: 'Location',
                        },
                        {
                            name: 'PlacingAgency',
                            title: "Placing Agency",
                            sortField: 'PlacingAgency',
                            //width: "15%"
                        },
                        {
                            name: 'ClientProgramMembership.LastCPAForm',
                            title: "Last CPA Form",
                            sortField: 'ClientProgramMembership.LastCPAForm',
                            callback: 'formatDate|MM/DD/YY'
                            //width: "15%"
                        },
                        {
                            name: 'ClientProgramMembership.Status',
                            title: "Status",
                            sortField: 'ClientProgramMembership.Status',
                        }
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetChildren(true);
                
            },
            GetChildren(displayLoad = false) {
                var vm = this;
                let openRecords = [];
                Object.keys(this.$store.state.Clients.ClientProfiles).map(function (key, index) {
                    openRecords.push(vm.$store.state.Clients.ClientProfiles[key].ClientProgramMembership.Id);
                   
                });
                if (displayLoad) {
                    vm.$store.commit("UI.BumpLoadsInProgress", 1);
                }
                this.clientsAPI.GetClients(this.Filters.ChildStatus, this.Filters.SubProgramID, this.Filters.CaseManagerID, openRecords).then((data) => {
                    if (displayLoad) {
                        vm.$store.commit("UI.BumpLoadsInProgress", -1);
                    }
                    this.RefreshTableFields(data);
                    this.$store.commit("Clients.ClientEnrollmentsList.ReplaceListOnly", data.data.ChildList);
                    this.$refs.datatable.refresh();
                });
            },
            GetAllCaseManagers() {
                let vm = this;
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FosterClients/GetAllCaseManagers", { SubProgramIDs: vm.SubProgramOptions.map(subProgram => subProgram.value) }, this.GetAllCaseManagersSuccess, () => { }, false);
            },
            GetAllCaseManagersSuccess(response) {
                this.CaseManagers = response.data.data;
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OpenChildRecord(subProgramMembershipID, childRecordData) {
                this.GetClientSingularRecord(subProgramMembershipID);
                
            },
            GetClientSingularRecord(SingleRecordID = null) {
                var vm = this;
                let openRecords = [];
                 Object.keys(this.$store.state.Clients.ClientProfiles).map(function (key, index) {
                    openRecords.push(vm.$store.state.Clients.ClientProfiles[key].ClientProgramMembership.Id);
                   
                 });
                //vm.$store.commit("UI.BumpLoadsInProgress", 1);
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FosterClients/GetClientEnrollment",
                    {
                        Id: SingleRecordID
                    }, this.GetClientSingularRecordSuccess, () => { }, false);
            },
            GetClientSingularRecordSuccess(response) {
                this.$store.commit("Clients.ClientProfiles.Append", response.data.data);
                this.$parent.ChangePaneShown(response.data.data.Id);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.$store.state.Clients.ClientEnrollmentsList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfClients = visibleData.length;
                return visibleData;                  
            },
            RefreshTableFields(response) {
                let vm = this;
                let outputArray = response.data.Columns.toString().split(',');
                let outputFields = [];

                //save fields from frontend that contain the property save.
                let columnsToSave = [];
                this.ChildrenTableOptions.Fields.forEach(function (col) {
                    if (col.hasOwnProperty("Save")) {
                        columnsToSave.push(col);
                    }
                });

                for (var i = 0; i < outputArray.length; i++)
                {
                    let fieldExists = this.ChildrenTableOptions.Fields.map(function (vc) { return vc.name; }).indexOf(outputArray[i]);
                    if (fieldExists != -1) {
                        outputFields[i] = this.ChildrenTableOptions.Fields[fieldExists];
                    }
                }
                this.VisibleFields = outputFields.concat(columnsToSave);
                this.$nextTick(function () {
                    vm.$refs.datatable.normalizeFields();
                });
            }
        },
        components: {
            Vuetable,
            EmployeeColumnCustomizationEditor
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
        },
        mounted() {
            this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            
            var vm = this;
            //Get Child Records*/
            this.GetChildren(true);
            let getchildrenFunc = function () {
                vm.GetChildren();
            };
            //this.$GlobalUpdate.AddGlobalUpdateFunction(getchildrenFunc);
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position:sticky;
        top:-1px;
        background:white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>